import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemState {
  timezones: any[];
  isLoadingTimezones: boolean;
  fetched: boolean;
  error: string | null;
}

const initialState: SystemState = {
  timezones: [],
  isLoadingTimezones: false,
  fetched: false,
  error: null,
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setLoadingTimezones: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTimezones = action.payload;
    },
    setTimezones: (state, action: PayloadAction<any[]>) => {
      state.timezones = action.payload;
      state.isLoadingTimezones = false;
      state.fetched = true;
      state.error = null;
    },
    setTimezonesError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoadingTimezones = false;
      state.fetched = true;
    },
  },
});

export const { setLoadingTimezones, setTimezones, setTimezonesError } = systemSlice.actions;
export default systemSlice.reducer;
